import type { AppRouter } from '@packages/api';
import { createTRPCReact, httpBatchLink, TRPCClientError } from '@trpc/react-query';
import superjson from 'superjson';

function getBaseUrl() {
  if (typeof window !== 'undefined') {
    // browser should use relative path
    return '';
  }
  if (process.env.VERCEL_URL) {
    // reference for vercel.com
    return `https://${process.env.VERCEL_URL}`;
  }
  if (process.env.RENDER_INTERNAL_HOSTNAME) {
    // reference for render.com
    return `http://${process.env.RENDER_INTERNAL_HOSTNAME}:${process.env.PORT}`;
  }
  // assume localhost
  return `http://localhost:${process.env.PORT ?? '3000'}`;
}

export const trpc = createTRPCReact<AppRouter>();

export const TRPCProvider = trpc.Provider;

export const trpcCreateClient = trpc.createClient({
  links: [
    httpBatchLink({
      transformer: superjson,
      url: `${getBaseUrl()}/api/trpc`,
      // You can pass any HTTP headers you wish here
      fetch: async (input, init) => {
        const res = await fetch(input, init);

        if (res.status === 413) {
          // Throw as a tRPC-style error
          throw new TRPCClientError('Payload too large');
        }

        return res;
      },
      async headers() {
        return {
          // authorization: getAuthCookie(),
        };
      },
    }),
  ],
});
